import {apiClient} from "@/state/modules/apiClient";
const controller = "ThongTinLienLac";
export const actions = {
    async getPagingParams({commit}, params) {
        return apiClient.post(controller + "/get-paging-params", params);
    },
    async update({commit, dispatch}, values) {
        return apiClient.put(controller +"/update", values);
    },
};
